<div mat-dialog-content>
  <p>Thank you for your request!<br/>Our team will be reaching out to you shortly.
    Please check your inbox.</p>
  <p class="font-weight-bold">**PLEASE CHECK YOUR JUNK/SPAM OR PROMOTIONS FOLDER**</p>
</div>
<div class="line"></div>
<div mat-dialog-actions class="actions-section">
  <button mat-button (click)="closeDialog()">ok</button>
</div>
